import { render, staticRenderFns } from "./produkHukum.vue?vue&type=template&id=433ca8b8&"
import script from "./produkHukum.vue?vue&type=script&lang=js&"
export * from "./produkHukum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QBtn,QInput,QIcon,QMarkupTable,QPagination,QDialog,QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnGroup,QBtn,QInput,QIcon,QMarkupTable,QPagination,QDialog,QCard,QCardSection,QCardActions})
